import {useState,useEffect,useContext} from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Card,CardBody,CardHeader } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { ProyectosAprobado } from '../../interfaces/ProyectoAprobado';
import axios from 'axios';
import {HiOutlineDocumentSearch} from 'react-icons/hi';
import { CasUserContext, useCasUserContext } from '../../services/casUserContext'; 
import Checkbox from '@mui/material/Checkbox';
import { certificado } from '../../interfaces/Certificados';
import AlertService from '../../services/AlertService';
import CertificadoService from '../../services/CertificadoService';
import { firmaCertificado } from '../../interfaces/Certificados';
import { Alert, AlertTitle, Button } from '@mui/material';
import SolicitarFirmaTable from './SolicitarFirmaTable';

import { Spinner } from 'reactstrap';

const alertaService = new AlertService;
const certificadoService = new CertificadoService;



const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));
export default function SolicitarFirmaDecano(){
    const[ready,SetReady] = useState(false);
    //const casUserContext = useContext(CasUserContext);
    const casUserContext = useCasUserContext();
    let history = useNavigate()
    const token = casUserContext.token;
    const emailInv = casUserContext.userData.emailAddress;
    const username = casUserContext.userData.username;
    let [proyectosCertificadosFirma,setProyectosCertificadosFirma] = useState<Array<firmaCertificado>>([]);

    const fetchData = async () =>{
      try{

        alertaService.showLoading("Cargando Datos...");  
        await certificadoService.GetCerficadosFirmaProyectosByEmail(emailInv,token) 
        .then((data)=>{
          if(data.status.isSuccessfully){
            setProyectosCertificadosFirma(data.listData);
          }
           SetReady(true);
        })           
        .catch((error) => console.error(error));               
        alertaService.hideLoading(); 

                          
      }catch(error){
        console.error('Error:',error);
      }
    };

    // useEffect(() => {      
    //   fetchData();
    // },[]);

    useEffect(() => { 
      //console.log(casUserContext.userData);     
      fetchData();
    },[token]);

      if(!ready){
        return <Spinner
      color="primary"
      style={{
        height: '3rem',
        width: '3rem'
      }}
      >
        Loading...
      </Spinner>; // Mostrar un indicador de carga mientras se obtienen los datos
      }

    return (

      <Card>
      <CardHeader><strong>Certificado de Participación en Proyectos</strong></CardHeader>
      <CardBody>
        <Alert severity="info">
            <AlertTitle>Info</AlertTitle>
              Estimado Investigador, para emitir un certificado de participación en proyectos de investigación, por favor escoja uno o más proyectos para que vayan incluidos.
        </Alert>
        <br />
        <SolicitarFirmaTable rowsPerPage={[5 ,10, 25, 100]} data={proyectosCertificadosFirma}  />        
      </CardBody>
   </Card>


    )
}